<template>
  <main
    class="bg-white h-full col-start-1 pl-4 md:pl-8 lg:pl-0 lg:col-start-3 col-end-13 relative z-10"
  >
    <grid-letters text="info" />
    <div class="relative z-10 pb-8">
      <div class="w-full h-full flex flex-wrap uppercase">
        <div
          class="w-full md:w-1/2 pr-4 flex-auto pt-4 md:pt-8 relative z-10 justify-items-center"
        >
          <div
            v-if="info.mission"
            class="mb-4 space-y-4"
            v-html="info.mission"
          ></div>
        </div>
        <div
          class="w-full md:w-1/4 flex-auto pt-4 md:pt-8 relative z-10 justify-items-center"
        >
          <div class="mb-4 space-y-4" v-html="info.text"></div>
          <div v-if="info.facebook" class="uppercase">
            <a
              :href="info.facebook"
              target="_blank"
              @mousemove="changeCursor('OPEN')"
              @mouseleave="changeCursor('')"
            >
              <img
                class="h-4 inline-block align-text-bottom pr-2"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1ieCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9InRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7Ij48cGF0aCBkPSJNMjAgM0g0YTEgMSAwIDAgMC0xIDF2MTZhMSAxIDAgMCAwIDEgMWg4LjYxNXYtNi45NmgtMi4zMzh2LTIuNzI1aDIuMzM4di0yYzAtMi4zMjUgMS40Mi0zLjU5MiAzLjUtMy41OTJjLjY5OS0uMDAyIDEuMzk5LjAzNCAyLjA5NS4xMDd2Mi40MmgtMS40MzVjLTEuMTI4IDAtMS4zNDguNTM4LTEuMzQ4IDEuMzI1djEuNzM1aDIuNjk3bC0uMzUgMi43MjVoLTIuMzQ4VjIxSDIwYTEgMSAwIDAgMCAxLTFWNGExIDEgMCAwIDAtMS0xeiIgZmlsbD0iY3VycmVudENvbG9yIj48L3BhdGg+PC9zdmc+"
                alt="Facebook"
              />THE SOMETHING MACHINE
            </a>
          </div>
          <div v-if="info.instagram" class="uppercase">
            <a
              :href="info.instagram"
              target="_blank"
              @mousemove="changeCursor('OPEN')"
              @mouseleave="changeCursor('')"
            >
              <img
                class="h-4 inline-block align-text-bottom pr-2"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgcm9sZT0iaW1nIiBjbGFzcz0iaWNvbmlmeSBpY29uaWZ5LS1ieCIgd2lkdGg9IjFlbSIgaGVpZ2h0PSIxZW0iIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9InRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7Ij48cGF0aCBkPSJNMjAuOTQ3IDguMzA1YTYuNTMgNi41MyAwIDAgMC0uNDE5LTIuMjE2YTQuNjEgNC42MSAwIDAgMC0yLjYzMy0yLjYzM2E2LjYwNiA2LjYwNiAwIDAgMC0yLjE4Ni0uNDJjLS45NjItLjA0My0xLjI2Ny0uMDU1LTMuNzA5LS4wNTVzLTIuNzU1IDAtMy43MS4wNTVhNi42MDYgNi42MDYgMCAwIDAtMi4xODUuNDJhNC42MDcgNC42MDcgMCAwIDAtMi42MzMgMi42MzNhNi41NTQgNi41NTQgMCAwIDAtLjQxOSAyLjE4NWMtLjA0My45NjMtLjA1NiAxLjI2OC0uMDU2IDMuNzFzMCAyLjc1NC4wNTYgMy43MWMuMDE1Ljc0OC4xNTYgMS40ODYuNDE5IDIuMTg3YTQuNjEgNC42MSAwIDAgMCAyLjYzNCAyLjYzMmE2LjU4NCA2LjU4NCAwIDAgMCAyLjE4NS40NWMuOTYzLjA0MyAxLjI2OC4wNTYgMy43MS4wNTZzMi43NTUgMCAzLjcxLS4wNTZhNi41OSA2LjU5IDAgMCAwIDIuMTg2LS40MTlhNC42MTUgNC42MTUgMCAwIDAgMi42MzMtMi42MzNjLjI2My0uNy40MDQtMS40MzguNDE5LTIuMTg3Yy4wNDMtLjk2Mi4wNTYtMS4yNjcuMDU2LTMuNzFjLS4wMDItMi40NDItLjAwMi0yLjc1Mi0uMDU4LTMuNzA5em0tOC45NTMgOC4yOTdjLTIuNTU0IDAtNC42MjMtMi4wNjktNC42MjMtNC42MjNzMi4wNjktNC42MjMgNC42MjMtNC42MjNhNC42MjMgNC42MjMgMCAwIDEgMCA5LjI0NnptNC44MDctOC4zMzljLS41OTcgMC0xLjA3OC0uNDgyLTEuMDc4LTEuMDc4YTEuMDc3IDEuMDc3IDAgMSAxIDIuMTU1IDBjMCAuNTk2LS40ODIgMS4wNzgtMS4wNzcgMS4wNzh6IiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48Y2lyY2xlIGN4PSIxMS45OTQiIGN5PSIxMS45NzkiIHI9IjMuMDAzIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvY2lyY2xlPjwvc3ZnPg=="
                alt="Instagram"
              />@THESOMETHINGMACHINE</a
            >
          </div>
        </div>
        <div
          class="w-full md:w-1/4 flex-auto pt-4 md:pt-8 relative z-10 justify-items-center"
        >
          &nbsp;
        </div>
        <div
          class="w-full md:w-1/6 relative md:fixed top-0 right-0 pt-4 md:pt-8 z-10"
        >
          <div class="mb-4">
            <a
              href="https://www.maltapavilion2022.com/"
              target="_blank"
              class="inline-block spinner cursor-none"
            >
              <img
                @mousemove="changeCursor('JEFFREY USLIP')"
                @mouseleave="changeCursor('')"
                class="origin-center h-48 w-auto"
                src="@/assets/logos/juslip3.svg"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="h-screen"></div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import GridLetters from "@/components/GridLetters.vue";
export default {
  name: "info",
  metaInfo() {
    return {
      title: "– Info",
    };
  },
  components: {
    GridLetters,
  },
  computed: mapState(["info"]),
  methods: {
    changeCursor(name) {
      this.$root.$emit("changeCursor", name);
    },
  },
};
</script>
